import { MallApi } from "@/api/MallApi";

const mallApi = new MallApi();
const basicUrl = '/gw/app'

const productDetailPageUrl = {
  wlDetailUrl: basicUrl + "/lywl/employee/activity/detail",
  jdDetailUrl: basicUrl + "/lywl/employee/scenery/detail",
};

export const loadlywlPageData = (params?: any) => {
  return mallApi.Post<any>(productDetailPageUrl.wlDetailUrl, params, {
    cacheData: true,
  });
};

export const loadJdPageData = (params?: any) => {
  return mallApi.Post<any>(productDetailPageUrl.jdDetailUrl, params, {
    cacheData: true,
  });
};
